// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-1dbedfa6]{padding-top:14px;position:relative;margin-bottom:14px}.box .title[data-v-1dbedfa6]{text-align:center;margin-bottom:30px;font-size:15px;font-weight:500;color:#000}[data-v-1dbedfa6] .el-dialog__header{border-bottom:none}[data-v-1dbedfa6] .el-form-item__label{font-size:14px;font-weight:400;color:#333}", ""]);
// Exports
module.exports = exports;
